import React, { useEffect, useState }from "react"
import PropTypes from "prop-types"

import Helmet from 'react-helmet'

import Header from './header'
import Footer from './footer'

import '../scss/main.scss'

const Layout = ({children,brandUrl,treeUrl,lang})=>{	
	const [visible,setVisible] = useState(true)

	useEffect(()=>{
		try {
			if ('IntersectionObserver' in window) {
				const footer = new IntersectionObserver(entries=>{
					if (!entries[0].isIntersecting) return setVisible(false)
					setVisible(true)
				})
				footer.observe(document.querySelector('footer'))
			} else {
				setVisible(true)
			}
		} catch (error){
			console.error(error)
		}
	},[])

	return (
		<div className="host-container">
			<div className="top-container">
				<Header brandUrl={brandUrl} />
				<main className="footer-visible">
					{children}
				</main>
			</div>
			<Footer brandUrl={brandUrl}  treeUrl={treeUrl} lang={lang}></Footer>
			<Helmet>
				<script async src="https://ui.vialog.io/vialog-loader.js"></script>
			</Helmet>			
		</div>
	)
}

Layout.propTypes = {
	children: PropTypes.node.isRequired,
}
Layout.defaultProps = {
	className: ''
}

export default Layout